import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,

      '& > header': {
        marginBottom: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },

      '& .MuiFormControlLabel-root': {
        '&:first-child': {
          marginBottom: '0.6rem',
        },

        '& .MuiFormControlLabel-label': {
          display: 'inline-flex',
          flex: 1,

          fontWeight: 600,
          fontSize: '1.2rem',

          '& span:first-child': {
            flex: 1,
            '&::first-letter': {
              textTransform: 'uppercase',
            },
          },
          '& span:last-child': {
            fontWeight: 400,
          },
        },

        '& .MuiCheckbox-root': {
          color: '#646464',

          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.primary.dark,
          },
        },

        '& + .MuiFormControlLabel-root .MuiCheckbox-root': {
          paddingTop: '0.4rem',
          paddingBottom: '0.4rem',
        },
      },
    },
    buttonContainer: {
      margin: '1rem 0',

      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',
      },
    },
  }),
)
